








import { Vue, Component } from "vue-property-decorator";
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
@Component({
  components: {
    Banner,
    SideBar
  }
})
export default class Index extends Vue {
  // 背景图样式文案
  list = {
    style: {
      "background-image": `url(${require("../../assets/pic29.png")})`,
      height: "280px"
    },
    font1: "招标公告",
    font2: "",
    font3: "走进浙华，了解浙华",
    font4: "",
    font5: "",
    button: ""
  };
}
